var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getUserUnavailableReason, } from '../../../lib/government-user-selection';
var getUserName = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    return [firstName, lastName].filter(function (part) { return part === null || part === void 0 ? void 0 : part.trim(); }).join(' ');
};
/**
 * Builds select options for user-like records. A user without a name is labelled with their email,
 * or "Unknown User" when that is missing too.
 *
 * Government users (records carrying their membership's `blockInternalAccess`) who can't be
 * selected stay in the list, disabled and labelled with the reason, so a field that already holds
 * one still displays it. Pair with `SearchSelect`'s `hideUnselectedDisabledOptions` to keep them
 * out of the menu otherwise.
 */
export function formatUserOptions(users, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.withEmail, withEmail = _c === void 0 ? false : _c;
    return users.map(function (user) {
        var name = getUserName(user);
        var label = withEmail && name && user.email
            ? "".concat(name, " (").concat(user.email, ")")
            : name || user.email || 'Unknown User';
        var option = {
            label: label,
            value: user.id,
            user: {
                avatarUrl: user.avatarUrl || undefined,
                firstName: user.firstName || undefined,
                lastName: user.lastName || undefined,
                email: user.email || undefined,
            },
        };
        var unavailableReason = 'blockInternalAccess' in user
            ? getUserUnavailableReason(user)
            : null;
        if (!unavailableReason) {
            return option;
        }
        return __assign(__assign({}, option), { label: "".concat(label, " (").concat(unavailableReason, ")"), statusLabel: unavailableReason, disabled: true });
    });
}
